import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import { Dialog, Pagination } from "../types";

const appConfigurationSection = "/configuration/appConfiguration/";

export const appConfigurationPath = appConfigurationSection;

export const appConfigPath = (id: string) => urlJoin(appConfigurationPath, id);

export type AppConfigurationUrlDialog = "create" | "update";
export type AppConfigurationUrlQueryParams = Dialog<AppConfigurationUrlDialog> &
  Pagination;
export const appConfigurationListUrl = (
  params?: AppConfigurationUrlQueryParams
) => appConfigurationPath + "?" + stringifyQs(params);

export const appConfigurationUrl = (
  id: string,
  params?: AppConfigurationUrlQueryParams
) => appConfigPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
